import "../css/loader.css";
import logo from "../image/logo.webp";

import resume1 from "../image/resume10.webp";
import resume2 from "../image/resume11.webp";
import resume3 from "../image/resume9.webp";
import resume4 from "../image/resume8.webp";
import resume5 from "../image/resume7.webp";
import { useEffect, useState } from "react";

const planets = [resume1, resume2, resume3, resume4, resume5];

const Loader = ({ fading }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(
      () => setIndex((prev) => (prev + 1) % planets.length),
      1000 // change planet every second
    );
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={`universe ${fading ? "fade-out" : ""}`}>
      {/* Stars Background */}
      <div className="stars"></div>
      <div className="stars-2"></div>
      <div className="stars-3"></div>

      {/* Brand Logo */}
      <img
        src={logo}
        className="loader-logo"
        alt="logo"
        style={{ borderRadius: "50%" }}
      />

      {/* Orbit system */}
      <div className="orbit">
        <img
          key={index}
          src={planets[index]}
          alt="planet"
          className="planet"
        />
      </div>
    </div>
  );
};

export default Loader;
